import axios from "axios"
import { setToken, refreshToken } from '../interceptors/jwt-interceptor'
import '../interceptors/loader-interceptor'
import '../interceptors/internal-server-interceptor'
import { apiErrorText } from '../shared/constant'
import { errorToastr } from '../services/error-handler'
var CryptoJS = require("crypto-js");


const apiUrl = process.env.GATASBY_API_URL;

export const generateAccessTokenFromRefresh = (data) => {
    if (typeof window === "undefined") {
        return
    }
    return new Promise((resolve, reject) => {
        axios
            .post(`${apiUrl}/generate-accessToken-from-refeshToken`, data)
            .then(res => {
                if (res.data?.accessToken) {
                    setToken(res.data)
                    resolve(res)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const getBranchList = (source) => {
    if (typeof window === "undefined") {
        return;
    }
    return new Promise((resolve, reject) => {
        axios
            .get(`${apiUrl}/get-branch-list?channel_id=${source}`)
            .then((res) => {
                // if(apiErrorText.includes(res?.status)){
                //     errorToastr(res.message)
                // }
                let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
                let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                res.data = decryptedData;
                if (res && res.data) {
                    resolve(res?.data)
                }
            })
            .catch(error => {
                if ([403].includes(error?.response?.status)) {
                    let payload = {
                        refreshToken: refreshToken
                    }
                    generateAccessTokenFromRefresh(payload)
                        .then(res => {
                            getBranchList(source)
                                .then(res => {
                                    console.log(res, "sdff")
                                    if (res && res.data) {
                                        resolve(res)
                                    }
                                })
                                .catch(error => {
                                    if ([500, 400].includes(error?.response?.status)) {
                                        errorToastr(error.response.data.message)
                                    }
                                    reject(error)
                                })
                        })
                        .catch(error => {
                            if ([500, 400].includes(error?.response?.status)) {
                                errorToastr(error.response.data.message)
                            }
                            reject(error)
                        })
                } else {
                    if ([500, 400].includes(error?.response?.status)) {
                        errorToastr(error.response.data.message)
                    }
                    reject(error)
                }
            })
    });
}

export const getBranchRm = (data) => {
    if (typeof window === "undefined") {
        return;
    }
    return new Promise((resolve, reject) => {
        axios
            .post(`${apiUrl}/get-branch-rm`, data)
            .then((res) => {
                // if(apiErrorText.includes(res?.status)){
                //     errorToastr(res.message)
                // }
                let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
                let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                res.data = decryptedData;
                if (res && res.data) {
                    resolve(res?.data)
                }
            })
            .catch(error => {
                if ([403].includes(error?.response?.status)) {
                    let payload = {
                        refreshToken: refreshToken
                    }
                    generateAccessTokenFromRefresh(payload)
                        .then(res => {
                            getBranchRm(data)
                                .then(res => {
                                    console.log(res, "sdff")
                                    if (res && res.data) {
                                        resolve(res)
                                    }
                                })
                                .catch(error => {
                                    if ([500, 400].includes(error?.response?.status)) {
                                        errorToastr(error.response.data.message)
                                    }
                                    reject(error)
                                })
                        })
                        .catch(error => {
                            if ([500, 400].includes(error?.response?.status)) {
                                errorToastr(error.response.data.message)
                            }
                            reject(error)
                        })
                } else {
                    if ([500, 400].includes(error?.response?.status)) {
                        errorToastr(error.response.data.message)
                    }
                    reject(error)
                }
            })
    });
}

